export const PRODUCTIVITY_OPTIONS = ["Fast", "Medium", "Slow","Manual"];
export const CLEANING_OPTIONS = ["Regular", "Allergen", "Enhanced"];
export const MACHINE_TOOL_OPTIONS = [
  "Long Screw Small",
  "Long Screw Medium",
  "Long Screw Large",
  "Short Small",
  "Short Large",
  "None",
  "Long-for-Bagging",
];

export const DEFAULT_PRODUCTIVITY = {
  fast: 1,
  medium: 1,
  slow: 1,
  manual: 1,
};

export const DEFAULT_CLEANING = {
  regular: 1,
  allergen: 1,
  enhanced: 1,
};

export const DEFAULT_MACHINE_TOOL = {
  long_screw_small: 1,
  long_screw_medium: 1,
  long_screw_large: 1,
  short_small: 1,
  short_large: 1,
  long_for_bagging: 1,
};
